<template lang="html">
  <b-card>
    <div slot="header">Transação #{{ tx.id | numeral('00000') }}</div>
    <div class="form-group row">
      <label for="uuid" class="col-sm-3 col-form-label">ID. interno</label>
      <div class="col-sm-9">
        <input type="text" readonly class="form-control-plaintext" id="uuid" :value="tx.uuid">
      </div>
    </div>
    <div class="form-group row">
      <label for="transactionSeller" class="col-sm-3 col-form-label">Loja</label>
      <div class="col-sm-9">
        <input type="text" readonly class="form-control-plaintext" id="transactionSeller" :value="tx.sellerName">
      </div>
    </div>
    <div class="form-group row">
      <label for="transactionStatus" class="col-sm-3 col-form-label">Status</label>
      <div class="col-sm-9">
        <input type="text" readonly class="form-control-plaintext" id="transactionStatus" :value="tx.status">
      </div>
    </div>
    <div class="form-group row">
      <label for="transactionDateCreated" class="col-sm-3 col-form-label">Data de Criação</label>
      <div class="col-sm-9">
        <input type="text" readonly class="form-control-plaintext" id="transactionDateCreated" :value="tx.dateCreated | moment-complete">
      </div>
    </div>
    <div class="form-group row">
      <label for="transactionAmount" class="col-sm-3 col-form-label">Valor Total</label>
      <div class="col-sm-9">
        <input type="text" readonly class="form-control-plaintext" id="transactionAmount" :value="tx.amount | numeral('$ 0,0.00')">
      </div>
    </div>
  </b-card>
</template>
<script>
export default {
  props: ['tx']
}
</script>
<style lang="scss">
  @import "../../../../assets/scss/variaveis.scss";
  @import "../../../../assets/scss/card.scss";
</style>



// WEBPACK FOOTER //
// src/components/partial/cards/transactions/TransactionDetails.vue